var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("\n            "+_vm._s(_vm.category.name)+"\n        ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.category.perex))])])
}
var staticRenderFns = []

export { render, staticRenderFns }